export enum ResultType {
    OK,
    Error,
    StreamData,
    DecryptedKeys,
    CertificatePublicInfo,
    VersionInfo,
}
